import { Box, Typography } from "@mui/material";
import React from "react";
import CreateUpdatePaintingTemplateForm from "../components/Common/CreateUpdatePaintingTemplateForm";
import TemplateList from "../components/Fabrication/TemplateList";
import usePaintTemplate from "../hooks/usePaintTemplate";
import DeleteConfirmationPopup from "../components/Common/DeleteConfirmationPopup";
import PartTemplateTable from "../components/Fabrication/PartTemplateTable";
import { actionType } from "../utils/constant";
import AppButton from "../components/Common/AppButton";
import { useNavigate } from "react-router-dom";

const styles = {
  nonPermissionContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "75vh",
    flexDirection: "column",
  },
};

const PaintingChecklistPage = () => {
  const {
    tableData,
    selectedTemplate,
    createModalDialogue,
    carausalCollapsed,
    handleSubmit,
    onTemplateDelete,
    createTemplateClick,
    onTemplateClick,
    setCarausalCollapsed,
    setSearchTerm,
    pagination,
    handlePageChange,
    deleteModal,
    setDeleteModal,
    setDeleteSelectedModel,
    deleteSelectedModel,
    loading,
    handleClose,
    onEditTemplateClick,
    deleting,
    formKey,
    selectedTemplateLoading,
    permissions,
  } = usePaintTemplate();

  const navigate = useNavigate();

  return (
    <>
      {permissions?.actions?.includes(actionType.template_view) ? (
        <Box>
          <TemplateList
            onTemplateClick={onTemplateClick}
            createTemplateClick={createTemplateClick}
            allTemplates={tableData}
            collapsed={carausalCollapsed}
            setCollapsed={setCarausalCollapsed}
            onTemplateDelete={(template) => {
              setDeleteModal(true);
              setDeleteSelectedModel(template);
            }}
            setSearchTerm={setSearchTerm}
            pagination={pagination}
            handlePageChange={handlePageChange}
            loading={loading}
            templateType="painting"
          />

          {(selectedTemplateLoading || selectedTemplate) && (
            <PartTemplateTable
              template={selectedTemplate}
              onEdit={onEditTemplateClick}
              loading={selectedTemplateLoading}
            />
          )}

          <CreateUpdatePaintingTemplateForm
            key={formKey}
            open={createModalDialogue}
            onClose={handleClose}
            onSave={handleSubmit}
            initialData={selectedTemplate}
            isEditing={!!selectedTemplate}
          />

          <DeleteConfirmationPopup
            open={deleteModal}
            onClose={() => setDeleteModal(false)}
            onConfirm={onTemplateDelete}
            itemName={deleteSelectedModel?.model_name}
            isLoading={deleting}
          />
        </Box>
      ) : (
        <Box sx={styles.nonPermissionContainer}>
          <Typography variant="h5" mb={3}>
            You don't have permission to view templates.
          </Typography>
          <AppButton
            label="Back to Dashboard"
            onClick={() => navigate("/dashboard")}
          />
        </Box>
      )}
    </>
  );
};

export default PaintingChecklistPage;
